import { Col, Container, Row, Button } from "react-bootstrap";
import ExternalLink from "@/assets/ExternalLink.svg";
import classes from "./styles.module.scss";
import clsx from "classnames";
import Image from "@/ui/Image";

const backgroundMap = {
  orangeBox: "/assets/grid/transparent.png",
  lightBlueBox: "/assets/grid/bg.png",
  darkBlueBox: "/assets/grid/transparent.png",
};

export const TextImageWithVariant = ({ className, content, image, buttonName, buttonUrl, buttonVariant, variant, reverse }) => {
  if (!backgroundMap[variant]) return null;

  const renderColumns = (textColClasses, backgroundPath) => {
    const textColumn = (
      <Col xs={12} md={6} className={clsx(textColClasses, "p-5 text-overlay")}>
        <div className="text-overlay__content mb-4" dangerouslySetInnerHTML={{ __html: content }} />
        {buttonUrl &&
          (buttonVariant === "primary" ? (
            <Button href={buttonUrl} className="mt-3 mt-md-0 position-relative z-10" variant="primary" tabIndex={undefined}>
              {buttonName}
              <ExternalLink className="ms-3" width="20" height="20" />
            </Button>
          ) : (
            <Button href={buttonUrl} className="mt-3 mt-md-0 position-relative z-10" variant="secondary" tabIndex={undefined}>
              {buttonName}
              <ExternalLink className="ms-3" width="20" height="20" />
            </Button>
          ))}
        {/* <Image className="text-overlay__background" img={{ src: backgroundPath }} size="x1000" alt="" /> */}
      </Col>
    );

    const imageColumn = (
      <Col xs={12} md={6} className={clsx(classes.content__image, "p-5")}>
        <img src={image?.url} alt={image?.alt} style={{ objectFit: "cover", objectPosition: "center right" }} />
      </Col>
    );

    return reverse ? [textColumn, imageColumn] : [imageColumn, textColumn];
  };

  return (
    <div className={clsx(className, classes.content)}>
      <Container>
        <Row>
          {renderColumns(
            clsx({
              "bg-primary text-white": variant === "orangeBox",
              "bg-light": variant === "lightBlueBox",
              "bg-secondary text-white": variant === "darkBlueBox",
            }),
            backgroundMap[variant]
          )}
        </Row>
      </Container>
    </div>
  );
};

export default TextImageWithVariant;
